import { translateBlockValue } from 'i18n';
import {
    AutocompletAble,
    formatValueForAutocomplete,
} from 'ui/DropdownItems/types';
import { BudgetBys } from 'business/constants';
import { VentilationOptions } from '../types';
import { ProjectionVentilation } from 'routes/BudgetModule/components/BudgetProposal/Resource/Projection/helpers/types';

/**
 * Returns a ventilation projection formatted as a dropdown value (compatible with our Autocomplete component)
 */
const formatVentilationIntoAutocompleteValues = (
    projectionVentilations: ProjectionVentilation.SoftwareIds[],
    softwares: Set<string>,
): AutocompletAble<ProjectionVentilation.SoftwareIds>[] =>
    projectionVentilations.map((projectionVentilation) =>
        formatValueForAutocomplete(
            projectionVentilation,
            false,
            translateBlockValue(projectionVentilation, true, softwares),
        ),
    );

const extractTableFromDimension = (value: string): string =>
    value.split('.')[0];

/**
 * Remove the current BudgetProposal.by (gestionnaire.name or orgChartFinance.tree) from the ventilations options.
 * Since the BudgetProposal.by is always the first, "root" projection ventilations, it would not have any sense
 * to ventilate again on it.
 */
const removeResourceByFromVentilationsOptions = (
    ventilationOptions: VentilationOptions,
    resourceBy: BudgetBys,
): ProjectionVentilation.SoftwareIds[] =>
    ventilationOptions.dimensions.filter(
        (d) =>
            extractTableFromDimension(d) !==
            extractTableFromDimension(resourceBy),
    );

/**
 * Build the list of available projection ventilations options.
 */
export const buildAvailableVentilationsValues = (
    ventilationOptions: VentilationOptions | undefined,
    resourceBy: BudgetBys,
    softwares: Set<string>,
): AutocompletAble<ProjectionVentilation.SoftwareIds>[] =>
    ventilationOptions
        ? formatVentilationIntoAutocompleteValues(
              removeResourceByFromVentilationsOptions(
                  ventilationOptions,
                  resourceBy,
              ),
              softwares,
          )
        : [];
